import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const ProfessionalsChartsDataContext = createContext();

const ProfessionalsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_PROFESSIONALS,
            url: 'governanceroom/esus/production/profissionals'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            service_type: filters.service_type_professionals.value,
            cbo: filters.cbo.map((cbo) => cbo.value),
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
            annualEvolution: data?.annualEvolution ?? [],
            evolutionByCbo: data?.evolutionByCbo ?? []
          }
        : {
            annualEvolution: [],
            evolutionByCbo: []
          };

    return (
        <ProfessionalsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ProfessionalsChartsDataContext.Provider>
    );
};

export default ProfessionalsChartsDataProvider;
